// import LoadingModal from "../../LoadingModal";

import useDecodeToken from "../../../../hooks/useDecodeToken";
import {
  hasAccessToDedicated,
  hasAccessToNetwork,
  isDemoAccount,
  isReadOnly,
} from "../../../../services/accountService";
import ShipViaFilter from "./ShipViaFilter";

/*
interface IFilterTableProps {
  className: string;
  clientID: number;
}
*/

function FilterTable({
  className,
  clientID,
  shipViaNetworkRef,
  shipViaDedicatedRef,
}) {
  const [decodedToken] = useDecodeToken();
  return (
    <div className={className}>
      <div className="cdk-filter-table-container paper-panel-tight container-fluid">
        <div className="row font-weight-bold px-2 py-3 border-bottom">
          <div className="col-6 col-lg-3 col-xl-2">Field</div>
          <div className="col-6 col-lg-9 col-xl-10">Filter By</div>
        </div>

        {hasAccessToNetwork(decodedToken) && (
          <div className="row px-2 py-3">
            <div className="col-6 col-lg-3 col-xl-2 mb-2 mb-lg-0">
              Ship Via (Network)
            </div>
            <div className="col-12 col-lg-9 col-xl-10">
              <ShipViaFilter
                clientID={clientID}
                ref={shipViaNetworkRef}
                isDedicated={false}
              />
            </div>
          </div>
        )}
        {hasAccessToDedicated(decodedToken) && (
          <div className="row px-2 py-3">
            <div className="col-6 col-lg-3 col-xl-2 mb-2 mb-lg-0">
              Ship Via (Dedicated)
            </div>
            <div className="col-12 col-lg-9 col-xl-10">
              {/* This is for Dedicated */}
              <ShipViaFilter
                clientID={clientID}
                ref={shipViaDedicatedRef}
                isDedicated={true}
                disabled={
                  isReadOnly(decodedToken) && !isDemoAccount(decodedToken)
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default FilterTable;
